import React, { useState, useEffect } from "react";
import "./PurchaseOptionsModal.css";
import MandatoryPurchaseModal from "../../Modals/mandatoryPurchaseModal/MandatoryPurchaseModal";
import PaymentSummaryModal from "../paymentSummaryModal/PaymentSummaryModal";

const PurchaseOptionsModal = ({
  isOpen,
  onClose,
  onProceed,
  onPayLater,
  event,
  onPurchaseClick,
  user,
}) => {
  const [modalType, setModalType] = useState(null);
  const [cashGiftAmount, setCashGiftAmount] = useState("");
  const [mandatoryPurchaseData, setMandatoryPurchaseData] = useState(null);

  const [showPaymentSummary, setShowPaymentSummary] = useState(false);
  const [cashGiftData, setCashGiftData] = useState(null);

  const closeModal = () => {
    setModalType(null);
    setCashGiftAmount("");
  };

  const formatCurrency = (amount) => {
    const num = typeof amount === "string" ? parseFloat(amount) : amount;

    if (num === 0) {
      return "Free";
    }

    const symbol = event?.preferredCurrency === "NGN" ? "₦" : "$";
    return `${symbol}${num.toLocaleString()}`;
  };

  const handlePurchaseClick = (type, options) => {
    setMandatoryPurchaseData({ type, options });
  };

  const CashGiftModal = () => {
    const [localCashGiftAmount, setLocalCashGiftAmount] = useState("");
    const [description, setDescription] = useState("");
    const [formattedValue, setFormattedValue] = useState("");

    const handleProceed = () => {
      const amount = parseFloat(localCashGiftAmount);
      if (isNaN(amount) || amount <= 0) {
        alert("Please enter a valid amount");
        return;
      }

      const cashGiftOption = {
        type: description || "Cash Gift",
        price: amount.toString(),
      };

      setCashGiftData({
        selectedOptions: [cashGiftOption],
        quantities: { [cashGiftOption.type]: 1 },
        isAttirePurchase: false,
        applyServiceCharge: false,
        description: description,
      });

      closeModal();
      setShowPaymentSummary(true);
    };

    const handleCashGiftAmountChange = (e) => {
      const value = e.target.value.replace(/[^0-9.]/g, "");
      setLocalCashGiftAmount(value);
      setFormattedValue(value);
    };

    const handleAmountBlur = () => {
      if (localCashGiftAmount) {
        setFormattedValue(formatCurrency(localCashGiftAmount));
      }
    };

    const handleAmountFocus = () => {
      setFormattedValue(localCashGiftAmount);
    };

    return (
      <div className="other-purchase-modal-overlay">
        <div className="other-purchase-modal-content">
          <button onClick={closeModal} className="modal-close-button">
            <span>×</span>
          </button>
          <div className="modal-body">
            <h2 className="purchase-title">Donate Cash Gift</h2>
            <p className="purchase-description">
              Enter the amount you wish to donate to support the event or host.
            </p>
            <div className="cash-gift-input-container">
              <label className="cash-gift-label">Amount</label>
              <div className="amount-input-container">
                <span className="amount-label prefix">
                  {event?.preferredCurrency || "NGN"}
                </span>

                <input
                  type="text"
                  placeholder="Enter amount"
                  value={formattedValue}
                  onChange={handleCashGiftAmountChange}
                  onBlur={handleAmountBlur}
                  onFocus={handleAmountFocus}
                  className="cash-gift-input"
                />
              </div>
              <div className="description-input-container">
                <label className="description-label">
                  Description (Optional)
                </label>
                <textarea
                  className="description-input"
                  placeholder="Enter a description..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={5}
                  cols={30}
                />
              </div>
            </div>
            <div className="modal-controls">
              <button
                onClick={closeModal}
                className="modal-button other-purchase-cancel"
              >
                Close
              </button>
              <button
                onClick={handleProceed}
                className="modal-button proceed-button"
                disabled={
                  !localCashGiftAmount || parseFloat(localCashGiftAmount) <= 0
                }
              >
                Proceed to Payment
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (!isOpen) return null;

  const allTicketsFree = event?.ticketFee?.every(
    (ticket) => parseFloat(ticket.price) === 0,
  );

  return (
    <>
      <div className="purchase-modal-overlay">
        <div className="purchase-modal-content">
          <button onClick={onClose} className="modal-close-button">
            <span>&times;</span>
          </button>
          <div className="purchase-modal-body">
            <img
              src={"/images/successModal.png"}
              alt="Event"
              className="purchase-event-image"
            />
            <h2 className="purchase-event-title">
              We're Glad You're Coming to {event?.eventTitle}
            </h2>
            <p className="purchase-event-description">
              A huge thank you for saying yes to our invite! We're excited to
              have you with us. Find more information about the event by
              clicking the proceed button below.{" "}
            </p>
            {event?.isEventAttireCompulsory && (
              <p className="purchase-note">
                Note: Event attire is mandatory for this event. Failure to
                purchase will cause your invite to be revoked.
              </p>
            )}
            <div className="purchase-options-container">
              {event?.isEventAttireAvailable && (
                <div className="purchase-option-row">
                  <div className="purchase-option-description">
                    <h3 className="purchase-option-title">
                      Event Attire
                      {event.isEventAttireCompulsory && (
                        <span className="required">*</span>
                      )}
                    </h3>
                    <p className="purchase-option-text">
                      Event Attire Available! Aso Ebi, Fila, Customized T-Shirt,
                      Caps, etc
                    </p>
                  </div>
                  <button
                    className="purchase-buy-button"
                    onClick={() =>
                      onPurchaseClick("attire", event.eventAttire.asoEbiImages)
                    }
                  >
                    Buy
                  </button>
                </div>
              )}
              {event?.isCashGiftAccepted && (
                <div className="purchase-option-row">
                  <div className="purchase-option-description">
                    <h3 className="purchase-option-title">Cash Gift</h3>
                    <p className="purchase-option-text">
                      You can donate a monetary gift to support the event or the
                      event host.
                    </p>
                  </div>
                  <button
                    className="purchase-donate-button"
                    onClick={() => setModalType("cashGift")}
                  >
                    Donate
                  </button>
                </div>
              )}
              {event?.isEntryFeeApplicable && (
                <div className="purchase-option-row">
                  <div className="purchase-option-description">
                    <h3 className="purchase-option-title">
                      Ticket (Entry Fee)
                      {event.isEntryFeeApplicable && (
                        <span className="required">*</span>
                      )}
                    </h3>
                    <p className="purchase-option-text">
                      {allTicketsFree
                        ? "This event offers free tickets! Claim yours now!"
                        : "This event requires a ticket for entry. Proceed to purchase your ticket now!"}
                    </p>
                  </div>
                  <button
                    className="purchase-buy-button"
                    onClick={() => onPurchaseClick("ticket", event.ticketFee)}
                  >
                    {allTicketsFree ? "Claim" : "Buy"}
                  </button>
                </div>
              )}
            </div>
            <div className="purchase-modal-buttons">
              <button
                onClick={() => {
                  onClose();
                  onPayLater();
                }}
                className="purchase-modal-close-button"
              >
                Buy Later
              </button>
              <button
                onClick={() => {
                  onProceed();
                }}
                className="purchase-proceed-button"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>

      {modalType === "cashGift" && <CashGiftModal />}

      {mandatoryPurchaseData && (
        <MandatoryPurchaseModal
          isOpen={true}
          type={mandatoryPurchaseData.type}
          options={mandatoryPurchaseData.options}
          onClose={closeModal}
          event={event}
          onProceed={() => console.log("Proceed clicked")}
          onPayLater={() => console.log("Pay later clicked")}
        />
      )}

      {showPaymentSummary && cashGiftData && (
        <PaymentSummaryModal
          isOpen={showPaymentSummary}
          onClose={() => {
            setShowPaymentSummary(false);
            setCashGiftData(null);
          }}
          onBack={() => {
            setShowPaymentSummary(false);
            setModalType("cashGift");
          }}
          event={event}
          selectedOptions={cashGiftData.selectedOptions}
          deliveryAddress={null}
          quantities={cashGiftData.quantities}
          isAttirePurchase={false}
          applyServiceCharge={false}
          user={user}
        />
      )}
    </>
  );
};

export default PurchaseOptionsModal;
